import * as React from 'react';
import {
   LeftAlignButton,
   CenterAlignButton,
   RightAlignButton,
   TopAlignButton,
   BottomAlignButton,
   MiddleAlignButton,
} from './buttons';
import { Menu, MenuButton, MenuList, IconButton, Tooltip } from '@chakra-ui/react';
import { tiptapButtonStyle } from './TiptapButton';
import { useEditorContext } from '../editor_context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAlignLeft, faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import { useLocalization } from '~/framework';
import { shadow } from '@dozuki/web-js/primitives';

export const AlignmentDropdown = () => {
   const { _js } = useLocalization();
   const { editor } = useEditorContext();

   return (
      <Menu onClose={() => setTimeout(() => editor.commands.focus(), 50)}>
         <Tooltip placement="top-start" label={_js('Align Text')}>
            <MenuButton
               as={IconButton}
               icon={<FontAwesomeIcon icon={faAlignLeft} />}
               // @ts-ignore (MenuButton is missing a TS definition for the rightIcon prop)
               // See https://github.com/chakra-ui/chakra-ui/issues/231
               rightIcon={<FontAwesomeIcon icon={faChevronDown} />}
               padding={1}
               {...tiptapButtonStyle}
            />
         </Tooltip>
         <MenuList minW="auto" padding={0} boxShadow={shadow[3]}>
            <LeftAlignButton />
            <CenterAlignButton />
            <RightAlignButton />
            <BottomAlignButton />
            <MiddleAlignButton />
            <TopAlignButton />
         </MenuList>
      </Menu>
   );
};
